import React from 'react';
import { ListItem, Collapse } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

export default function CollapseListItem(props) {
  const [DrawerOpen, setOpen] = React.useState(false);

  function handleClick(event) {
    setOpen(!DrawerOpen);
  };

  function MakeCollapse() {
    if (props.collapseItem[0]) {
      return (DrawerOpen 
        ? <ExpandLess style={{ alignSelf: "center" }} /> 
        : <ExpandMore style={{ alignSelf: "center" }} />
      );
    } else {
      return "";
    }
  }

  return (
    <div key={props.mainItem+props.collapseItem}>
      <ListItem
        button
        onClick={handleClick}
        disableGutters
        alignItems="flex-start"
        style={{ flexDirection: "row", justifyContent: "space-between" }}
      >
        {props.mainItem}
        {MakeCollapse()}
      </ListItem>
      <Collapse in={DrawerOpen} timeout="auto" unmountOnExit>
        {props.collapseItem}
      </Collapse>
    </div>
  );
}

